import { usePendingSectorsCount, useSectorActions } from '../hooks';
import { ISector, InboxStats } from '../models';
import { SectorsHeader } from './SectorsHeader';
import { StatsPanel } from './StatsPanel';
import { SectorList } from './SectorList';

interface SectorsProps {
  selectedSector: ISector | null;
  stats?: InboxStats;
  onCallNext: () => void;
  isLoadingCallNext: boolean;
  setSelectedSector: (sector: ISector) => void;
}

const Sectors = ({
  selectedSector,
  stats,
  onCallNext,
  isLoadingCallNext,
  setSelectedSector,
}: SectorsProps) => {
  const { pendingSectorsCount } = usePendingSectorsCount();
  const { onSelectSector, onToggleLock } = useSectorActions({
    selectedSector,
    setSelectedSector,
  });

  const headerTitle = selectedSector?.id
    ? `Estás atendiendo al sector ${selectedSector.name}`
    : 'Seleccioná un sector';

  const headerDescription = [
    'Seleccioná un sector para comenzar a atender a los clientes.',
    'Podés cambiar de sector en cualquier momento.',
    'Si presionás un candado, evitarás atender otro sector.',
  ];

  return (
    <div className='flex flex-col gap-8'>
      <div className='flex flex-col gap-2 p-2 rounded-[2.5rem] border border-gray-100/50'>
        <SectorsHeader title={headerTitle} description={headerDescription} />

        {stats && <StatsPanel stats={stats} />}
      </div>

      <SectorList
        sectors={pendingSectorsCount || []}
        selectedSector={selectedSector}
        onSelectSector={onSelectSector}
        onToggleLock={onToggleLock}
        onCallNext={selectedSector?.id ? onCallNext : undefined}
        isLoadingCallNext={isLoadingCallNext}
        sectorName={selectedSector?.name}
      />
    </div>
  );
};

export default Sectors;
